import { RotateCcw, X } from "lucide-react";

const AVATAR = "/jerry.png";

export default function ChatHeader({ canReset, onReset, onClose }) {
    return (
        <header className="px-5 py-4 bg-[#0E2A47] text-white flex items-center justify-between">
            <div className="flex items-center gap-3">
                <div className="relative">
                    <img
                        src={AVATAR}
                        alt="Jerry"
                        className="h-10 w-10 rounded-full object-cover ring-2 ring-white/20"
                    />
                    <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-[#7BA37F] ring-2 ring-[#0E2A47]" />
                </div>
                <div className="leading-tight">
                    <p className="font-[Outfit] font-semibold text-[15px]">Jerry</p>
                    <p className="text-[11.5px] text-white/70">
                        Virtual Receptionist · Crossroads to Change Residential Treatment Center
                    </p>
                </div>
            </div>
            <div className="flex items-center gap-1">
                <button
                    onClick={onReset}
                    aria-label="Start a new conversation"
                    data-testid="chatbot-reset-button"
                    disabled={!canReset}
                    className="rounded-full p-1.5 hover:bg-white/15 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    title="New conversation"
                >
                    <RotateCcw className="h-4 w-4" />
                </button>
                <button
                    onClick={onClose}
                    aria-label="Close chat"
                    data-testid="chatbot-close-button"
                    className="rounded-full p-1.5 hover:bg-white/15 transition-colors"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </header>
    );
}
